import { render, staticRenderFns } from "./kdMarketingManagerAudit.vue?vue&type=template&id=23bd5e2c&scoped=true"
import script from "./kdMarketingManagerAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./kdMarketingManagerAudit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bd5e2c",
  null
  
)

export default component.exports